import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class OrdenpedidoService {

  constructor(
    private apiService: ApiService,
    private http: HttpClient
  ) { }

  visar(numint: number, coduser: string) {//sin descuento
    return this.http.put(environment.serviceUrl + `ordenPedido/${numint}/visar?` + "coduser=" + coduser, { observe: 'response' });
  }
  cerrar(numint: number) {//sin descuento
    return this.http.put(environment.serviceUrl + `ordenPedido/${numint}/cerrar`, { observe: 'response' });
  }
  aprobar(numint: number, coduser: string) {//sin descuento
    return this.http.put(environment.serviceUrl + `ordenPedido/${numint}/aprobar?` + "coduser=" + coduser, { observe: 'response' });
  }

  desaprobar(numint: number, coduser: string) {//sin descuento
    return this.http.put(environment.serviceUrl + `ordenPedido/${numint}/desaprobar?` + "coduser=" + coduser, { observe: 'response' });
  }

  observacion(numint: number, observ: string) {//sin descuento
    return this.http.put(environment.serviceUrl + `ordenPedido/${numint}/observacion?` + "observ=" + observ, { observe: 'response' });
  }

  rechazar(numint: number, coduser: string) {//sin descuento
    return this.http.put(environment.serviceUrl + `ordenPedido/${numint}/rechazar?` + "coduser=" + coduser, { observe: 'response' });
  }

  anular(numint: number, coduser: string) {//sin descuento
    return this.http.put(environment.serviceUrl + `ordenPedido/${numint}/anular?` + "coduser=" + coduser, {}, { observe: 'response' });
  }
  anular_v2(numint: number, comentario: string) {//sin descuento
    return this.http.put(environment.serviceUrl + `ordenPedido/${numint}/anular?` + "comentario=" + comentario, {}, { observe: 'response' });
  }

  buscar(fdesde: Date, fhasta: Date, codcli: string, codven: number, codsuc: number, situac: string, lugemi: number, limit: number, offset: number): Observable<any> {
    this.apiService.setUrlPathApi('ordenPedido/buscar?');
    return this.apiService.execGetQueryJson(`fdesde=${fdesde}&fhasta=${fhasta}&codcli=${codcli}&codven=${codven}&codsuc=${codsuc}&situac=${situac}&lugemi=${lugemi}&limit=${limit}&offset=${offset}`);
  }

  getListDetallesPendientes(numints: string) {
    this.apiService.setUrlPathApi('documento-generico/detalle-pendiente?');
    return this.apiService.execGetQueryJson(`numints=${numints}`);
    //return this.http.get(`${this.clienteService.getUrlSession().urlService}/documento-generico/detalle-pendiente?numints=${numints}`, { observe: 'response' });
  }


 
  

  download_pdf(_formato: number, numint: number, cia: string) {
    let fullUrl: any = null;
    // if (_formato == 1)
    //   fullUrl = environment.serviceUrl + `ordenPedido/${numint}/report/public/format-1.pdf?` + "cia=" + cia;
    // if (_formato == 2)
    //   fullUrl = environment.serviceUrl + `ordenPedido/${numint}/report/public/format-2.pdf?` + "cia=" + cia;

    if (_formato == 1)
      fullUrl = environment.serviceUrl_Report + `ordenPedido/${numint}/report/public/format-default.pdf?` + "cia=" + cia;
    if (_formato == 2)
      fullUrl = environment.serviceUrl_Report + `ordenPedido/${numint}/report/public/format-default-codadd.pdf?` + "cia=" + cia;
    if (_formato == 3)
      fullUrl = environment.serviceUrl_Report + `ordenPedido/${numint}/report/public/format-default.pdf?` + "cia=" + cia;
    if (_formato == 4)
      fullUrl = environment.serviceUrl_Report + `ordenPedido/${numint}/report/public/format-default-codadd.pdf?` + "cia=" + cia;

    const httpOptions = {
      'responseType': 'arraybuffer' as 'json'
    };
    return this.http.get(fullUrl, httpOptions);
  }

  obtenerOrdenPedido(numint: number): Observable<any> {
    this.apiService.setUrlPathApi('ordenPedido');
    return this.apiService.execGetQueryJson(`/${numint}`).pipe();
  }

  obtenerFactura(numint: number): Observable<any> {
    this.apiService.setUrlPathApi('factura');
    return this.apiService.execGetQueryJson(`/${numint}`).pipe();
  }

  obtenerBoleta(numint: number): Observable<any> {
    this.apiService.setUrlPathApi('boleta');
    return this.apiService.execGetQueryJson(`/${numint}`).pipe();
  }

  downloadExcelComercialResportesOrdenPedido(fdesde: Date, fhasta: Date, codcli: string, codven: number, codsuc: number, situac: string, codmot: number, limit: number, offset: number): Observable<any> {
    this.apiService.setUrlPathApi('consultas/orden-pedido');
    return this.apiService.execGetQueryJsonPDF(`/excel.xlsx?fdesde=${fdesde}&fhasta=${fhasta}&codcli=${codcli}&codven=${codven}&codsuc=${codsuc}&situac=${situac}&codmot=${codmot}&limit=${limit}&offset=${offset}`).pipe();
  }

}
